import React, { memo } from 'react';

import './SeparatorWithText.css';

type SeparatorWithTextProps = {
  text: string;
};

export const SeparatorWithText: React.FC<SeparatorWithTextProps> = memo(
  ({ text }) => {
    return (
      <div className="separator-with-text--separator-container">
        <div className="sign-up--line" />
        <p className="separator-with-text--separator-paragraph">{text}</p>
        <div className="separator-with-text--line" />
      </div>
    );
  }
);
